<div class="if-menu-section-cabinet" [class.full-height]="isFullHeight()">
    <ng-content></ng-content>
</div>